<template>
  <div>
    <div class="container box">
      <div class="">
        <h1 class="is-size-4 mt-3 mb-5">Manage Users</h1>
        <!--<span class="has-text-primary has-text-weight-bold is-size-4">
              <i class="mdi mdi-account-group-outline"></i>
              Users Dashboard</span
            > -->
        <b-loading :is-full-page="true" v-model="loading" :can-cancel="false">
        </b-loading>

        <b-button
          tag="router-link"
          to="/admin/self-registration-log"
          icon-left="eye"
          type="is-info"
          size="is-small"
          class="mb-2"
          outlined
          rounded
        >
          View self-registration log
        </b-button>

        <div class="columns has-alt-font">
          <div class="column">
            <div class="box">
              <nav class="level">
                <div class="level-item has-text-centered">
                  <div>
                    <p class="heading">Number of Users</p>
                    <p class="title">{{ noOfUsers }}</p>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>

        <br />
        <b-dropdown :triggers="['hover']" aria-role="list">
          <template #trigger>
            <b-tooltip
              label="Select one or more users"
              position="is-top"
              :animated="false"
            >
              <b-button
                label="Bulk Actions"
                type="is-primary"
                size="is-small"
                icon="account-coge"
                icon-right="menu-down"
              ></b-button>
            </b-tooltip>
          </template>

          <b-dropdown-item
            @click="assignTravelManagerModal"
            aria-role="listitem"
            :disabled="selectedContacts.length == 0"
            >Assign Travel Manager</b-dropdown-item
          >
          <b-dropdown-item
            v-if="policies.length > 0"
            :disabled="selectedContacts.length == 0"
            @click="assignTravelPolicyModal"
            aria-role="listitem"
            >Assign Travel Policy/Rule Group</b-dropdown-item
          >
        </b-dropdown>
        &nbsp;
        <b-button
          v-if="checkedRows.length > 0"
          label="Clear checked"
          type="is-primary"
          size="is-small"
          icon-left="close"
          class="field"
          :disabled="checkedRows.length < 1"
          @click="clearCheckedRows"
        ></b-button>
        <div class="field is-grouped is-pulled-right">
          <p class="control">
            <b-button
              size="is-small"
              type="is-primary"
              icon-left="train-car"
              @click="uploadTravelerProgramModal"
            >
              Upload Travel Programs
            </b-button>
          </p>
          <p class="control">
            <b-button
              size="is-small"
              type="is-primary"
              icon-left="upload"
              @click="uploadModal"
            >
              Upload User List
            </b-button>
          </p>
          <p class="control">
            <b-button
              size="is-small"
              type="is-primary"
              icon-left="plus"
              @click="addUserModal"
            >
              Add User
            </b-button>
          </p>
        </div>
        <br />
        <br />
        <users-table :users="users" v-if="users.length > 0"></users-table>
      </div>
    </div>
    <br class="is-hidden-touch" />
    <br class="is-hidden-touch" />
    <br class="is-hidden-touch" />
  </div>
</template>
<script>
import UsersTable from "@/components/MyUsers/UsersTable";
import UserUploadModal from "@/components/MyUsers/UserUploadModal.vue";
import TravelerProgramUploadModal from "@/components/MyUsers/TravelerProgramUploadModal.vue";

import AddUserModal from "@/components/MyUsers/AddUserModal.vue";
import AssignTravelPolicyModal from "@/components/MyUsers/AssignTravelPolicyModal.vue";
import AssignTravelManagerModal from "@/components/MyUsers/AssignTravelManagerModal.vue";

export default {
  name: "ManageUsersPage",
  components: {
    UsersTable,
  },
  data() {
    return {
      users: [],
      loading: true,
      policies: [],
    };
  },
  methods: {
    async getUsers() {
      console.log("Running get users");
      this.loading = true;
      var body = { contactId: this.profile.id };
      this.$app
        .huddleLabsServerCall("profile/contacts", body)
        .then((result) => {
          if (!result.error) {
            this.$store.commit(
              "userManagement/ADD_COMPANY_CONTACTS",
              result.data
            );

            this.users = result.data;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$buefy.toast.open({
            message: "Couldn't fetch any users",
            type: "is-danger",
          });
        });

      return this.users;
    },

    async getPolicy() {
      var body = { 
        accountId: this.$globals.profile.account.id,
        includeDetails: false,
      };
      
      this.$app
        .huddleLabsServerCall("profile/travel-policy/list", body)
        .then((result) => {
          console.log(result.data);
          this.policies = result.data;
        });
    },
    clearCheckedRows() {
      this.$store.state.userManagement.checkedRows = [];
    },

    uploadModal() {
      var details = {
        parent: this,
        component: UserUploadModal,
        props: {
          profile: this.profile,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
        events: {
          "upload-success": () => {
            this.getUsers();
          },
        },
      };
      this.$buefy.modal.open(details);
    },
    uploadTravelerProgramModal() {
      var details = {
        parent: this,
        component: TravelerProgramUploadModal,
        props: {
          profile: this.profile,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
        events: {
          "upload-success": () => {
            this.getUsers();
          },
        },
      };
      this.$buefy.modal.open(details);
    },

    assignTravelManagerModal() {
      var details = {
        parent: this,
        component: AssignTravelManagerModal,
        props: {
          selectedContacts: this.selectedContacts,
          policies: this.policies,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
        events: {
          success: () => {
            this.getUsers();
            this.clearCheckedRows();
          },
        },
      };
      this.$buefy.modal.open(details);
    },
    addUserModal() {
      var details = {
        parent: this,
        component: AddUserModal,
        props: {
          profile: this.profile,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
        events: {
          "upload-success": () => {
            this.getUsers();
          },
        },
      };
      this.$buefy.modal.open(details);
    },
    assignTravelPolicyModal() {
      var details = {
        parent: this,
        component: AssignTravelPolicyModal,
        props: {
          selectedContacts: this.selectedContacts,
          policies: this.policies,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
        events: {
          success: () => {
            this.getUsers();
            this.clearCheckedRows();
          },
        },
      };
      this.$buefy.modal.open(details);
    },
  },
  mounted() {
    this.clearCheckedRows();
    this.getUsers();
    this.getPolicy();
  },
  computed: {
    profile() {
      return this.$globals.profile;
    },
    noOfUsers() {
      if (this.users.length > 0) return this.users.length;
      else return 0;
    },
    selectedContacts() {
      const result = this.checkedRows.map((item) => item.id);
      return result;
    },
    checkedRows() {
      return this.$store.state.userManagement.checkedRows;
    },
  },
};
</script>

<style scoped></style>
